/**
 * Default SVG icon for the application favicon
 * Using currentColor allows for easy color changes
 */export const defaultIconSvg=`<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <rect width="32" height="32" rx="8" fill="currentColor"/>
  <path d="M8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16C24 20.4183 20.4183 24 16 24" stroke="white" stroke-width="2" stroke-linecap="round"/>
  <path d="M16 24C13.7909 24 12 22.2091 12 20C12 17.7909 13.7909 16 16 16" stroke="white" stroke-width="2" stroke-linecap="round"/>
  <circle cx="16" cy="16" r="2" fill="white"/>
</svg>`;/**
 * Status colors for the favicon
 */export const iconColors={default:'#3B82F6',// Blue
success:'#10B981',// Green
warning:'#F59E0B',// Amber
error:'#EF4444',// Red
info:'#6366F1'// Indigo
};